const en = {
  backToRepairs: '← Back to Repairs',
  printCustomer: '🖨️ Print (Customer)',
  printDealer: '🖨️ Print (Dealer)',
  shiplabel: '📦 Shiplabel',
  erpDocIdLabel: 'ERP Document',
  newStatusLabel: 'New Status',
  notesOptional: 'Notes (optional)',
  updateStatus: 'Update Status',
  ticketDetails: 'Ticket Details',
  unsavedChanges: 'Unsaved changes...',
  savedCheck: 'Saved ✓',
  failedToSave: 'Failed to save: {{error}}',
  newLabel: '+ New',
  editArrow: 'Edit ↗',
  shippingLabel: 'Shipping',
  invoicingLabel: 'Invoicing',
  carrierLabel: 'Carrier',
  shipAddressLabel: 'Shipping address',
  shipAddressNone: 'No address on file',
  shipAddressSelectFirst: 'Select a customer/dealer first',
  shipCustomLabel: 'Different shipping address (shipping only, billing unchanged)',
  shipName: 'Name',
  shipStreet: 'Street / No.',
  shipZip: 'ZIP',
  shipCity: 'City',
  warranty: 'Warranty',
  costEstimateRequested: 'Cost estimate requested',
  hidePriceForCustomer: 'Hide price for customer',
  externalReference: 'External Reference',
  dealerReference: 'Dealer Reference',
  dealerReferenceHint:
    "The dealer's own PO/reference number -- passed through to the ERP invoice when set.",
  laborCost: 'Labor (CHF)',
  smallMaterialCost: 'Small Material (CHF)',
  shippingCost: 'Shipping (CHF)',
  discountPercent: 'Goodwill (%)',
  discountLabel: 'Goodwill ({{percent}}%)',
  saveDetails: 'Save Details',
  partsUsed: 'Parts Used',
  searchOrCreatePart: 'Search or create part...',
  noPartsRecorded: 'No parts recorded yet.',
  partCol: 'Part',
  qtyCol: 'Qty',
  unitPriceCol: 'Unit Price',
  amountCol: 'Amount',
  actionCol: 'Action',
  importedFromNotion: 'Imported from Notion, no live stock link',
  partsLabel: 'Parts',
  laborLabel: 'Labor',
  smallMaterialLabel: 'Small Material',
  attachments: 'Attachments',
  uploading: 'Uploading...',
  addFiles: '+ Add Files',
  imagesCompressedHint: 'Images are automatically compressed to WebP.',
  noFilesAttached: 'No files attached yet.',
  statusHistory: 'Status History',
  noHistoryYet: 'No history yet.',
  devicesHeading: 'Devices',
  noDevicesAttached: 'No devices attached yet.',
  searchSerialOrCreate: 'Search serial number or create new...',
  assignedTo: 'Assigned To',
  noOneAssigned: 'No one assigned yet.',
  selectEmployee: 'Select employee',
  deleteTicketTitle: 'Delete Repair Ticket',
  deleteTicketMessage:
    'Are you sure you want to delete ticket {{ticketId}}? This is blocked while parts usage is still recorded.',
  newCustomerTitle: 'New Customer',
  nameRequired: 'Name *',
  emailLabel: 'Email',
  phoneLabel: 'Phone',
  streetLabel: 'Street',
  numberLabel: 'Number',
  zipLabel: 'ZIP',
  cityLabel: 'City',
  createCustomer: 'Create Customer',
  errorLoadingTicket: 'Error loading repair ticket: {{error}}',
  failedToSaveGeneric: 'Failed to save',
  failedToAddPart: 'Failed to add part',
  failedToDeleteTicket: 'Failed to delete ticket',
  uploadFailed: 'Upload failed',
  failedToCreateCustomer: 'Failed to create customer',
  failedToGenerateShiplabel: 'Failed to generate shiplabel',
};

const de = {
  backToRepairs: '← Zurück zu Reparaturen',
  printCustomer: '🖨️ Drucken (Kunde)',
  printDealer: '🖨️ Drucken (Händler)',
  shiplabel: '📦 Versandetikett',
  erpDocIdLabel: 'ERP-Dokument',
  newStatusLabel: 'Neuer Status',
  notesOptional: 'Notizen (optional)',
  updateStatus: 'Status aktualisieren',
  ticketDetails: 'Auftragsdetails',
  unsavedChanges: 'Ungespeicherte Änderungen...',
  savedCheck: 'Gespeichert ✓',
  failedToSave: 'Speichern fehlgeschlagen: {{error}}',
  newLabel: '+ Neu',
  editArrow: 'Bearbeiten ↗',
  shippingLabel: 'Versand',
  invoicingLabel: 'Rechnungsstellung',
  carrierLabel: 'Versanddienst',
  shipAddressLabel: 'Lieferadresse',
  shipAddressNone: 'Keine Adresse hinterlegt',
  shipAddressSelectFirst: 'Zuerst Kunde/Händler wählen',
  shipCustomLabel: 'Andere Lieferadresse (nur Versand, Rechnung unverändert)',
  shipName: 'Name',
  shipStreet: 'Strasse / Nr.',
  shipZip: 'PLZ',
  shipCity: 'Ort',
  warranty: 'Garantie',
  costEstimateRequested: 'Kostenvoranschlag angefordert',
  hidePriceForCustomer: 'Preis für Kunde ausblenden',
  externalReference: 'Externe Referenz',
  dealerReference: 'Händlerreferenz',
  dealerReferenceHint:
    'Die eigene Bestell-/Referenznummer des Händlers -- wird bei Angabe an die ERP-Rechnung weitergegeben.',
  laborCost: 'Arbeitszeit (CHF)',
  smallMaterialCost: 'Kleinmaterial (CHF)',
  shippingCost: 'Versand (CHF)',
  discountPercent: 'Kulanz (%)',
  discountLabel: 'Kulanz ({{percent}}%)',
  saveDetails: 'Details speichern',
  partsUsed: 'Verwendete Teile',
  searchOrCreatePart: 'Teil suchen oder anlegen...',
  noPartsRecorded: 'Noch keine Teile erfasst.',
  partCol: 'Teil',
  qtyCol: 'Menge',
  unitPriceCol: 'Einzelpreis',
  amountCol: 'Betrag',
  actionCol: 'Aktion',
  importedFromNotion: 'Aus Notion importiert, keine Live-Lagerverknüpfung',
  partsLabel: 'Teile',
  laborLabel: 'Arbeitszeit',
  smallMaterialLabel: 'Kleinmaterial',
  attachments: 'Anhänge',
  uploading: 'Wird hochgeladen...',
  addFiles: '+ Dateien hinzufügen',
  imagesCompressedHint: 'Bilder werden automatisch als WebP komprimiert.',
  noFilesAttached: 'Noch keine Dateien angehängt.',
  statusHistory: 'Statusverlauf',
  noHistoryYet: 'Noch kein Verlauf.',
  devicesHeading: 'Geräte',
  noDevicesAttached: 'Noch keine Geräte angehängt.',
  searchSerialOrCreate: 'Seriennummer suchen oder neu anlegen...',
  assignedTo: 'Zugewiesen an',
  noOneAssigned: 'Noch niemand zugewiesen.',
  selectEmployee: 'Mitarbeiter auswählen',
  deleteTicketTitle: 'Reparaturauftrag löschen',
  deleteTicketMessage:
    'Möchten Sie den Auftrag {{ticketId}} wirklich löschen? Dies ist blockiert, solange noch Teileverbrauch erfasst ist.',
  newCustomerTitle: 'Neuer Kunde',
  nameRequired: 'Name *',
  emailLabel: 'E-Mail',
  phoneLabel: 'Telefon',
  streetLabel: 'Straße',
  numberLabel: 'Nummer',
  zipLabel: 'PLZ',
  cityLabel: 'Ort',
  createCustomer: 'Kunde erstellen',
  errorLoadingTicket: 'Fehler beim Laden des Reparaturauftrags: {{error}}',
  failedToSaveGeneric: 'Speichern fehlgeschlagen',
  failedToAddPart: 'Teil konnte nicht hinzugefügt werden',
  failedToDeleteTicket: 'Auftrag konnte nicht gelöscht werden',
  uploadFailed: 'Hochladen fehlgeschlagen',
  failedToCreateCustomer: 'Kunde konnte nicht erstellt werden',
  failedToGenerateShiplabel: 'Versandetikett konnte nicht erstellt werden',
};

const repairReport = { en, de };
export default repairReport;
